import { Grid, Typography, useTheme } from "@mui/material"
import ImageDisplay from "components/ImageDisplayer"
import Paragraph from "components/ReadMoreParagraph"
import React, { useState } from "react"
import editIcon from "assets/icons/edit.svg"
import trashIcon from "assets/icons/trash.svg"
import classes from "pages/private/marketing/menu/menu.module.scss"
import { useDispatch, useSelector } from "react-redux"
import { hotelAction } from "redux/hotel/slice/user"
import { deleteHotelServiceItemAction, getCategoryItemsAction } from "redux/hotel/action"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import CallMadeIcon from "@mui/icons-material/CallMade"
import { highlightText } from "helpers/functions"

const ListView = ({
  isEdit = false,
  categoryList,
  setIsEditItem,
  categoryIdData,
  handleAddNewItem,
  checkDetailView,
  searchedText
}) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState(false)
  const [itemId, setItemId] = useState("")
  const { linkNestedCategory } = useSelector((store) => store?.hotel ?? {})

  const handleEditClick = (id, categoryId) => {
    dispatch(hotelAction.setItemId(id))
    dispatch(hotelAction.setItemCategoryId(categoryId))
    dispatch(getCategoryItemsAction(id))
    setIsEditItem(true)
    handleAddNewItem()
  }

  const handleDelete = (id) => {
    setOpenModal(true)
    setItemId(id)
  }

  const onDelete = () => {
    dispatch(deleteHotelServiceItemAction({ id: itemId, nestedId: linkNestedCategory?.id }))
    setOpenModal(false)
  }

  const floorPlanPdfUrl = categoryList?.dynamic_fields
    ?.find((item) => item.type === "file_image_download")
    ?.value?.find((val) => val.type === "file")?.value?.[0]?.url

  return (
    <>
      <DeleteConfirmationDialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        onDelete={() => onDelete()}
        description="Are you sure you want to delete this item ?"
      />
      <div
        style={{
          border: `${
            isEdit || checkDetailView(linkNestedCategory?.list)
              ? `1px solid ${theme.palette.secondary.main}`
              : "none"
          }`,
          borderRadius: `${isEdit || checkDetailView(linkNestedCategory?.list) ? "6px" : "0px"}`,
          padding: `${isEdit || checkDetailView(linkNestedCategory?.list) ? "8px" : "0px"}`,
          margin: "24px 0"
        }}>
        <div className={classes.itemContainer} style={{ margin: 0, minHeight: "200px" }}>
          <div
            className={classes.imageContainer}
            style={{ display: "flex", flexDirection: "column" }}>
            <ImageDisplay data={categoryList?.images[0]?.url}></ImageDisplay>
            {(isEdit || checkDetailView(linkNestedCategory?.list)) && (
              <Grid item container justifyContent="center" mt={1}>
                {floorPlanPdfUrl && (
                  <a
                    href={floorPlanPdfUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}>
                    <Typography
                      sx={{
                        textDecoration: "underline",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px"
                      }}>
                      Floor Plan <CallMadeIcon sx={{ fontSize: "12px" }} />
                    </Typography>
                  </a>
                )}
              </Grid>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              maxWidth: 375,
              overflowWrap: "break-word"
            }}>
            <div>
              <Typography variant="h4">{categoryList?.name ?? "-"}</Typography>
              <Typography variant="tagItalic" sx={{ opacity: 0.6, wordBreak: "break-all" }}>
                {categoryList?.description?.length > 100 ? (
                  <Paragraph
                    text={categoryList?.description}
                    maxCharCount={100}
                    renderText={(txt) => highlightText(txt, searchedText)}
                  />
                ) : (
                  categoryList?.description ?? "-"
                )}
              </Typography>
            </div>
            {(isEdit || checkDetailView(linkNestedCategory?.list)) && (
              <div>
                {categoryList?.dynamic_fields?.map((section, index) => {
                  const values = Array.isArray(section?.value) ? section.value : []

                  return (
                    <div key={index}>
                      {values.length > 0 && (
                        <div className="mt-2">
                          {values.map((field, fieldIndex) => {
                            if (field?.type !== "text") return null
                            return (
                              <div key={fieldIndex} style={{ marginBottom: 8 }}>
                                <Typography variant="tag1">{field.label}</Typography>

                                <Typography
                                  component="div"
                                  sx={{
                                    opacity: 0.6,
                                    fontSize: 12,
                                    fontWeight: "400",
                                    fontStyle: "italic",
                                    wordBreak: "break-all"
                                  }}>
                                  {typeof field?.value === "string" ? (
                                    field?.value?.includes("\n") ? (
                                      field?.value
                                        .split("\n")
                                        .map((line, i) =>
                                          line.length > 70 ? (
                                            <Paragraph
                                              key={i}
                                              text={line}
                                              maxCharCount={70}
                                              renderText={(txt) => highlightText(txt, searchedText)}
                                            />
                                          ) : (
                                            <div key={i}>{highlightText(line, searchedText)}</div>
                                          )
                                        )
                                    ) : field.value.length > 70 ? (
                                      <Paragraph
                                        text={field.value}
                                        maxCharCount={70}
                                        renderText={(txt) => highlightText(txt, searchedText)}
                                      />
                                    ) : (
                                      highlightText(field?.value, searchedText) || "-"
                                    )
                                  ) : null}
                                </Typography>
                              </div>
                            )
                          })}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
          <div className="d-grid">
            <div className="d-flex justify-content-between">
              <div>
                {categoryList?.price > 0 && (
                  <Typography variant="bold">${categoryList?.price}</Typography>
                )}
              </div>
              {isEdit && (
                <div className="d-flex ms-2">
                  <div className="d-grid justify-content-center mt-1">
                    <img
                      src={editIcon}
                      alt="edit"
                      className={classes.menu_action_icon}
                      onClick={() => handleEditClick(categoryList?.id, categoryIdData)}
                    />
                  </div>
                  <div className="d-grid justify-content-center mt-1 ms-2">
                    <img
                      className={classes.menu_action_icon}
                      src={trashIcon}
                      alt=""
                      onClick={() => handleDelete(categoryList?.id)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ListView
